import { AdminApiService } from '../services/general';
import type { TaskUpdate } from '../services/general';

export type GetTasksPayload = {
  filters?: {
    contactId?: string | null;
    campaignId?: string | null;
    status?: string | null;
    taskType?: string | null;
  };
  page: PaginationType;
};

export const getTasks = ({ filters, page }: GetTasksPayload) => {
  return AdminApiService.getTasksApiAdminTasksGet(
    filters?.contactId,
    filters?.campaignId,
    filters?.status,
    filters?.taskType,
    page?.limit,
    page?.offset
  );
};

export const updateTask = (id: string, payload: TaskUpdate) => {
  return AdminApiService.updateTaskApiAdminTasksTaskIdPatch(id, payload);
};
export const deleteTask = (id: string) => {
  return AdminApiService.deleteTaskApiAdminTasksTaskIdDelete(id);
};

export type { TaskResponse } from '../services/general';
export type TaskUpdatePayload = TaskUpdate;
